import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-material-loader',
  templateUrl: './material-loader.component.html',
  styleUrls: ['./material-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialLoaderComponent implements OnInit {
  @Input() fillContainer = false;

  constructor() {}

  ngOnInit() {}
}
